import axios from './request'

const URL = {
  // 获取渠道
  getBankChannel: '/FINANCEBASEINFO-SERVER/bankChannel/getBankChannelListByMarketId.magpie',
  // 用户Id和渠道号查附属账户
  queryAccountDetailByUserId: '/FINANCEBASEINFO-SERVER/subsidiaryAccountApp/getMySubAccountDetail.magpie',
  // 市场id查询平台银行账户
  getAccountListByMarketId: '/PLATFORM-ACCOUNT-SERVER/goodsPlatformAccount/getAccountListByMarketId.magpie',
  // 获取用户市场键值对
  marketList: '/JURISDICTION-SERVICE-MAGPIE/current/markets.magpie',
  // 获取所有市场
  allMarket: '/JURISDICTION-SERVICE-MAGPIE/current/allMarket.magpie',
  // 公共基础模块大部分的下拉框接口
  getSelect: '/BASE-DATADICT/extbasedatadict/getSelect.magpie',

}

// 我的账户
class Common {
  /**
   * 获取市场下拉列表 （片区用户管理模块、）
   */
  getMarketList () {
    const url = URL.marketList
    const param = {}
    return axios.post(url, param)
  }
  /**
   * 获取所有市场
   */
  getAllMarket () {
    const url = URL.allMarket
    const param = {}
    return axios.post(url, param)
  }
  /**
   * 列表
   * @param {object} params
   */
  getBankChannel (params) {
    const url = URL.getBankChannel

    return axios.post(url, params)
  }

  /**
   * 用户Id和渠道号查附属账户
   * @param {object} params
   */
  getByUserId (params) {
    const url = URL.queryAccountDetailByUserId
    return axios.post(url, params)
  }

  /**
   * 市场id查询平台银行账户
   * @param {object} params
   */
  getAccountListByMarketId (params) {
    const url = URL.getAccountListByMarketId
    return axios.post(url, params)
  }
  /**
   * 获取通用下拉接口
   * @param {string} selectType 查询value值
   */
  getSelectData (selectType) {
    const url = URL.getSelect
    const param = {
      selectType
    }
    return axios.post(url, param)
  }
}

export default new Common()
